export const endpoints = {
  query: '/event/query',
}
